var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterInstaImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0_2074_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0H3.5C1.57517 0 0 1.57449 0 3.5V10.5C0 12.4248 1.57517 14 3.5 14H10.5C12.4248 14 14 12.4248 14 10.5V3.5C14 1.57449 12.4248 0 10.5 0ZM7 9.91655C5.38894 9.91655 4.08328 8.61034 4.08328 7C4.08328 5.38894 5.38894 4.08328 7 4.08328C8.61034 4.08328 9.91672 5.38894 9.91672 7C9.91672 8.61034 8.61034 9.91655 7 9.91655ZM10.7917 4.08328C10.308 4.08328 9.91672 3.69144 9.91672 3.20828C9.91672 2.72511 10.308 2.33328 10.7917 2.33328C11.2754 2.33328 11.6667 2.72511 11.6667 3.20828C11.6667 3.69144 11.2754 4.08328 10.7917 4.08328Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstaImg);
export default __webpack_public_path__ + "static/media/footer-insta-img.5fc28e8e57ef7e9663ad4e8a48955180.svg";
export { ForwardRef as ReactComponent };